<ax-icon *ngIf="icon" class="icon type-icon" [name]="icon"></ax-icon>

<mat-slide-toggle
  color="primary"
  [name]="getName()"
  [checked]="checked"
  (change)="changed($event)"
  [disabled]="form.disabled || readonly"
>
  {{ label | translate }}
</mat-slide-toggle>
<mat-hint class="hint" align="end">
  {{ hint }}
</mat-hint>
<mat-error *ngIf="errorsTemplate">
  <ng-template [ngTemplateOutlet]="errorsTemplate"></ng-template>
</mat-error>
